(function () {
  'use strict';

  var cache = window.OptimusVehicleSearchCache || (window.OptimusVehicleSearchCache = {});
  var modeStorageKey = 'optimus-preferred-search-mode';
  function optiLang() { return String(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase(); }
  function tr(key) {
    var dict = {
      fr:{since:'depuis ',until:'jusqu’en ',all_versions:'Toutes versions',no_size:'Aucune dimension fiable n’est disponible pour cette version.',one_size:'Une seule dimension est indiquée pour cette version.',many_sizes:' dimensions sont possibles. Vérifiez la dimension inscrite sur le flanc de votre pneu.',choose_model:'Choisissez un modèle',choose_model_first:'Choisissez d’abord un modèle',choose_variant:'Choisissez une version',choose_size:'Choisissez une dimension avant d’afficher les pneus.',choose_brand:'Choisissez une marque',temp_unavailable:'Recherche temporairement indisponible',load_error:'La recherche par véhicule n’a pas pu être chargée. La recherche par marque et taille reste disponible.',original_fitment:'Monte d’origine',exclude:'hors ',inches:'pouces',brakes:'freins',holes:'trous'},
      en:{since:'since ',until:'until ',all_versions:'All versions',no_size:'No reliable size is available for this version.',one_size:'Only one size is listed for this version.',many_sizes:' sizes are possible. Check the size shown on your tyre sidewall.',choose_model:'Choose a model',choose_model_first:'Choose a model first',choose_variant:'Choose a version',choose_size:'Choose a size before viewing tyres.',choose_brand:'Choose a brand',temp_unavailable:'Search temporarily unavailable',load_error:'The vehicle search could not be loaded. Search by brand and size remains available.',original_fitment:'Original fitment',exclude:'excl. ',inches:'inches',brakes:'brakes',holes:'holes'},
      de:{since:'seit ',until:'bis ',all_versions:'Alle Versionen',no_size:'Für diese Version ist keine verlässliche Reifengröße verfügbar.',one_size:'Für diese Version ist nur eine Reifengröße hinterlegt.',many_sizes:' Reifengrößen sind möglich. Prüfen Sie die Angabe auf der Reifenflanke.',choose_model:'Modell auswählen',choose_model_first:'Wählen Sie zuerst ein Modell',choose_variant:'Version auswählen',choose_size:'Wählen Sie eine Reifengröße, bevor Sie Reifen anzeigen.',choose_brand:'Marke auswählen',temp_unavailable:'Suche vorübergehend nicht verfügbar',load_error:'Die Fahrzeugsuche konnte nicht geladen werden. Die Suche nach Marke und Größe bleibt verfügbar.',original_fitment:'Erstausrüstung',exclude:'ohne ',inches:'Zoll',brakes:'Bremsen',holes:'Löcher'},
      es:{since:'desde ',until:'hasta ',all_versions:'Todas las versiones',no_size:'No hay una medida fiable disponible para esta versión.',one_size:'Solo hay una medida registrada para esta versión.',many_sizes:' medidas son posibles. Comprueba la medida indicada en el flanco del neumático.',choose_model:'Elige un modelo',choose_model_first:'Elige primero un modelo',choose_variant:'Elige una versión',choose_size:'Elige una medida antes de ver los neumáticos.',choose_brand:'Elige una marca',temp_unavailable:'Búsqueda temporalmente no disponible',load_error:'No se ha podido cargar la búsqueda por vehículo. La búsqueda por marca y medida sigue disponible.',original_fitment:'Equipo original',exclude:'excepto ',inches:'pulgadas',brakes:'frenos',holes:'agujeros'},
      it:{since:'dal ',until:'fino al ',all_versions:'Tutte le versioni',no_size:'Non è disponibile una misura affidabile per questa versione.',one_size:'Per questa versione è indicata una sola misura.',many_sizes:' misure sono possibili. Verifica quella riportata sul fianco del pneumatico.',choose_model:'Scegli un modello',choose_model_first:'Scegli prima un modello',choose_variant:'Scegli una versione',choose_size:'Scegli una misura prima di visualizzare i pneumatici.',choose_brand:'Scegli una marca',temp_unavailable:'Ricerca temporaneamente non disponibile',load_error:'La ricerca per veicolo non è stata caricata. La ricerca per marca e misura resta disponibile.',original_fitment:'Primo equipaggiamento',exclude:'escl. ',inches:'pollici',brakes:'freni',holes:'fori'},
      nl:{since:'sinds ',until:'tot ',all_versions:'Alle uitvoeringen',no_size:'Voor deze uitvoering is geen betrouwbare bandenmaat beschikbaar.',one_size:'Voor deze uitvoering is slechts één bandenmaat vermeld.',many_sizes:' bandenmaten zijn mogelijk. Controleer de maat op de zijkant van uw band.',choose_model:'Kies een model',choose_model_first:'Kies eerst een model',choose_variant:'Kies een uitvoering',choose_size:'Kies een bandenmaat voordat u banden bekijkt.',choose_brand:'Kies een merk',temp_unavailable:'Zoeken tijdelijk niet beschikbaar',load_error:'Zoeken op voertuig kon niet worden geladen. Zoeken op merk en maat blijft beschikbaar.',original_fitment:'Originele montage',exclude:'excl. ',inches:'inch',brakes:'remmen',holes:'gaten'}
    };
    var lang = optiLang();
    return (dict[lang] && dict[lang][key]) || dict.fr[key] || key;
  }

  function localizedPath(root, path) {
    var value = String(path || '');
    if (/^https?:\/\//i.test(value)) return value;
    var localeRoot = String(root && root.dataset && root.dataset.root || '/');
    if (localeRoot.charAt(0) !== '/') localeRoot = '/' + localeRoot;
    if (localeRoot.charAt(localeRoot.length - 1) !== '/') localeRoot += '/';
    var clean = value.replace(/^\/+/, '');
    return localeRoot === '/' ? '/' + clean : localeRoot + clean;
  }

  function option(value, label) {
    var node = document.createElement('option');
    node.value = value;
    node.textContent = label;
    return node;
  }

  function resetSelect(select, message, disabled) {
    select.replaceChildren(option('', message));
    select.disabled = disabled;
    select.value = '';
  }

  function periodLabel(start, end) {
    var startYear = start ? start.slice(0, 4) : '';
    var endYear = end ? end.slice(0, 4) : '';
    if (startYear && endYear && startYear === endYear) return startYear;
    if (startYear && endYear) return startYear + '–' + endYear;
    if (startYear) return tr('since') + startYear;
    if (endYear) return tr('until') + endYear;
    return '';
  }

  function variantLabel(variant) {
    var parts = [];
    var type = (variant.type || tr('all_versions'))
      .replace(/^All types\b/i, tr('all_versions'))
      .replace(/\bOE with\b/gi, tr('original_fitment'))
      .replace(/\bexcl\.\s*/gi, tr('exclude'))
      .replace(/\bex\.\s*/gi, tr('exclude'))
      .replace(/\binch\b/gi, tr('inches'));
    var typeCode = (variant.type_code || '')
      .replace(/^ex\b/i, tr('exclude').trim())
      .replace(/\bbrakes\b/gi, tr('brakes'))
      .replace(/\bholes?\b/gi, tr('holes'));
    parts.push(type);
    if (typeCode) parts.push(typeCode);
    var period = periodLabel(variant.year_month_start, variant.year_month_end);
    if (period) parts.push(period);
    return parts.join(' · ');
  }

  function sizeSort(a, b) {
    var partsA = a.match(/\d+/g).map(Number);
    var partsB = b.match(/\d+/g).map(Number);
    for (var i = 0; i < 3; i += 1) {
      if (partsA[i] !== partsB[i]) return partsA[i] - partsB[i];
    }
    return 0;
  }

  function decodeIndex(data) {
    if (!data || !Array.isArray(data.s) || !Array.isArray(data.m)) throw new Error('Format invalide');
    return {
      makes: data.m.map(function (make) {
        return {
          name: make[0],
          models: make[1].map(function (model) {
            return {
              name: model[0],
              variants: model[1].map(function (variant, position) {
                return {
                  id: String(position),
                  type: variant[0],
                  type_code: variant[1],
                  year_month_start: variant[2],
                  year_month_end: variant[3],
                  sizes: variant[4].map(function (sizeId) { return data.s[sizeId]; })
                };
              })
            };
          })
        };
      })
    };
  }

  function loadIndex(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      }).then(function (data) {
        return decodeIndex(data);
      });
    }
    return cache[url];
  }

  function readPreferredMode(fallback) {
    try {
      var saved = window.localStorage.getItem(modeStorageKey);
      return saved === 'vehicle' || saved === 'manual' ? saved : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function savePreferredMode(mode) {
    try {
      window.localStorage.setItem(modeStorageKey, mode);
    } catch (error) {
      return;
    }
  }

  function setMode(root, mode, moveFocus) {
    root.querySelectorAll('[data-search-mode]').forEach(function (button) {
      var selected = button.dataset.searchMode === mode;
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
      button.tabIndex = selected ? 0 : -1;
      if (selected && moveFocus) button.focus();
    });

    root.querySelectorAll('[data-search-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.searchPanel !== mode;
    });

    root.dataset.activeMode = mode;
    savePreferredMode(mode);
  }

  function initModeSwitch(root) {
    var buttons = Array.from(root.querySelectorAll('[data-search-mode]'));
    var fallback = root.dataset.defaultMode === 'manual' ? 'manual' : 'vehicle';
    var preferred = readPreferredMode(fallback);
    var preferredAvailable = buttons.some(function (button) {
      return button.dataset.searchMode === preferred;
    });
    setMode(root, preferredAvailable ? preferred : fallback, false);

    buttons.forEach(function (button, position) {
      button.addEventListener('click', function () {
        setMode(root, button.dataset.searchMode, false);
      });

      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = (position + direction + buttons.length) % buttons.length;
        setMode(root, buttons[next].dataset.searchMode, true);
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.vehicleSearchReady === 'true') return;
    root.dataset.vehicleSearchReady = 'true';

    var form = root.querySelector('[data-vehicle-form]');
    var manualForm = root.querySelector('[data-manual-form]');
    var makeSelect = root.querySelector('[data-vehicle-make]');
    var modelSelect = root.querySelector('[data-vehicle-model]');
    var variantSelect = root.querySelector('[data-vehicle-variant]');
    var sizesFieldset = root.querySelector('[data-vehicle-sizes]');
    var sizeOptions = root.querySelector('[data-size-options]');
    var sizeHelp = root.querySelector('[data-size-help]');
    var submit = root.querySelector('[data-vehicle-submit]');
    var status = root.querySelector('[data-vehicle-status]');
    var manualStatus = root.querySelector('[data-manual-status]');
    var index;

    initModeSwitch(root);

    /*
      La collection Moto ne rend volontairement que le formulaire manuel.
      Le routage de ce formulaire est géré par optimus-search-mesh-v2.js.
    */
    if (!form || !makeSelect || !modelSelect || !variantSelect || !sizesFieldset || !sizeOptions || !submit || !status) {
      return;
    }

    function clearSizes() {
      sizeOptions.replaceChildren();
      sizesFieldset.hidden = true;
      submit.disabled = true;
    }

    function renderSizes(variant) {
      clearSizes();
      if (!variant || !Array.isArray(variant.sizes) || !variant.sizes.length) {
        status.textContent = tr('no_size');
        return;
      }

      var sizes = variant.sizes.slice().sort(sizeSort);
      sizes.forEach(function (size, position) {
        var id = 'VehicleSize-' + root.id + '-' + position;
        var label = document.createElement('label');
        label.className = 'optimus-vehicle-search__size';
        label.setAttribute('for', id);

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'vehicle-size-' + root.id;
        input.id = id;
        input.value = size;
        input.required = true;
        input.addEventListener('change', function () {
          submit.disabled = false;
          status.textContent = '';
        });

        var text = document.createElement('span');
        text.textContent = size;
        label.append(input, text);
        sizeOptions.append(label);
      });

      sizesFieldset.hidden = false;
      if (sizes.length === 1) {
        var onlyChoice = sizeOptions.querySelector('input');
        onlyChoice.checked = true;
        submit.disabled = false;
        sizeHelp.textContent = tr('one_size');
      } else {
        sizeHelp.textContent = sizes.length + tr('many_sizes');
      }
    }

    makeSelect.addEventListener('change', function () {
      resetSelect(modelSelect, tr('choose_model'), true);
      resetSelect(variantSelect, tr('choose_model_first'), true);
      clearSizes();
      status.textContent = '';

      var make = index.makes.find(function (item) { return item.name === makeSelect.value; });
      if (!make) return;
      make.models.forEach(function (model) { modelSelect.append(option(model.name, model.name)); });
      modelSelect.disabled = false;
    });

    modelSelect.addEventListener('change', function () {
      resetSelect(variantSelect, tr('choose_variant'), true);
      clearSizes();
      status.textContent = '';

      var make = index.makes.find(function (item) { return item.name === makeSelect.value; });
      var model = make && make.models.find(function (item) { return item.name === modelSelect.value; });
      if (!model) return;
      model.variants.forEach(function (variant) {
        variantSelect.append(option(variant.id, variantLabel(variant)));
      });
      variantSelect.disabled = false;
    });

    variantSelect.addEventListener('change', function () {
      var make = index.makes.find(function (item) { return item.name === makeSelect.value; });
      var model = make && make.models.find(function (item) { return item.name === modelSelect.value; });
      var variant = model && model.variants.find(function (item) { return item.id === variantSelect.value; });
      renderSizes(variant);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var selected = form.querySelector('input[type="radio"]:checked');
      var match = selected && selected.value.match(/^(\d{3})\/(\d{2,3})R(\d{2})$/i);
      if (!match) {
        status.textContent = tr('choose_size');
        return;
      }

      var destination = new URL(localizedPath(root, root.dataset.target || '/collections/pneus'), window.location.origin);
      destination.searchParams.set('filter.p.m.custom.width', match[1]);
      destination.searchParams.set('filter.p.m.custom.height', match[2]);
      destination.searchParams.set('filter.p.m.custom.diameter', match[3]);
      destination.searchParams.set('filter.v.availability', '1');
      window.location.assign(destination.toString());
    });

    manualForm.addEventListener('submit', function (event) {
      event.preventDefault();
      manualStatus.textContent = '';
      if (!manualForm.checkValidity()) {
        manualForm.reportValidity();
        return;
      }

      var brandSelect = manualForm.querySelector('[data-manual-brand]');
      var brandHandle = brandSelect.value;
      var season = manualForm.querySelector('[data-manual-season]').value;
      var width = manualForm.querySelector('[data-manual-width]').value.trim();
      var height = manualForm.querySelector('[data-manual-height]').value.trim();
      var diameter = manualForm.querySelector('[data-manual-diameter]').value.trim();
      var params = new URLSearchParams();
      var seasonTag = {
        'Hiver': 'Saison_Hiver',
        'Été': 'Saison_Ete',
        '4 Saisons': 'Saison_4Saisons'
      }[season] || '';
      var base = brandHandle ? localizedPath(root, '/collections/' + brandHandle) : localizedPath(root, root.dataset.target || '/collections/pneus');

      if (width) params.set('filter.p.m.custom.width', width);
      if (height) params.set('filter.p.m.custom.height', height);
      if (diameter) params.set('filter.p.m.custom.diameter', diameter);

      if (seasonTag) base += '/' + encodeURIComponent(seasonTag);
      var queryString = params.toString();
      window.location.assign(base + (queryString ? '?' + queryString : ''));
    });

    root.classList.add('is-loading');
    status.textContent = 'Chargement des véhicules…';
    loadIndex(root.dataset.source)
      .then(function (data) {
        if (!data || !Array.isArray(data.makes)) throw new Error('Format invalide');
        index = data;
        resetSelect(makeSelect, tr('choose_brand'), false);
        index.makes.forEach(function (make) { makeSelect.append(option(make.name, make.name)); });
        status.textContent = '';
      })
      .catch(function () {
        resetSelect(makeSelect, tr('temp_unavailable'), true);
        status.textContent = tr('load_error');
        root.classList.add('has-error');
      })
      .finally(function () {
        root.classList.remove('is-loading');
      });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-optimus-vehicle-search]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
